import { SAVE_ADMIN_USER } from '../actions/adminUser'
import { IS_NOT_AUTHENTICATED } from '../actions/security'

const adminUser = (state = null, action) => {
  if (action.type === SAVE_ADMIN_USER) {
    return action.adminUser
  } else if (action.type === IS_NOT_AUTHENTICATED) {
    return null
  } else {
    return state
  }
}

export default adminUser
